import { Routes } from '@angular/router';
import { RegisterComponent } from './components/auth/register/register.component';
import { HomeComponent } from './components/global/home/home.component';
import { LayoutComponent } from './components/global/layout/layout.component';
import { VerificationComponent } from './components/auth/verification/verification.component';
import { PaymentDetailsComponent } from './components/account/payment-details/payment-details.component';
import { RecoverAccountComponent } from './components/auth/recover-account/recover-account.component';
import { ChangePasswordComponent } from './components/auth/change-password/change-password.component';
import { PaymentPlanComponent } from './components/account/payment-plan/payment-plan.component';
import { ProjectsComponent } from './components/projects/projects.component';
import { ProjectDevelopmentComponent } from './components/projects/project-development/project-development.component';
import { RevisionComponent } from './components/projects/project-development/revision/revision.component';
import { ProfileComponent } from './components/account/profile/profile.component';
import { AddProjectComponent } from '@/app/components/projects/project-stages/project-brief/add-project/add-project.component';
import { OverviewComponent } from './components/projects/project-stages/project-brief/add-project-module/brief-sections/overview/overview.component';
import { PlanSectionsComponent } from './components/projects/project-stages/plan-sections/plan-sections.component';
import { IttWorkPackagesComponent } from './components/projects/project-development/tendering/inivitation-to-tender/itt-sender-side/itt-creation/itt-work-packages/itt-work-packages.component';
import { CustomGeneratedComponent } from './components/projects/project-stages/plan-sections/custom-generated/custom-generated.component';
import { ManualGeneratedComponent } from './components/projects/project-stages/plan-sections/custom-generated/manual-generated/manual-generated.component';
import { CostEstimationComponent } from './components/projects/project-stages/plan-sections/cost-estimation/cost-estimation.component';
import { RaciMatrixComponent } from './components/projects/project-stages/plan-sections/raci-matrix/raci-matrix.component';
import { MultiSelectBoxExampleComponent } from './components/projects/project-stages/plan-sections/multi-select-box-example/multi-select-box-example.component';
import { RiskAssessmentComponent } from './components/projects/project-stages/plan-sections/risk-assessment/risk-assessment.component';
import { AddRiskComponent } from './components/projects/project-stages/plan-sections/risk-assessment/add-risk/add-risk.component';
import { Stage1viewmodeComponent } from '@/app/components/projects/project-stages/project-brief/stage1viewmode/stage1viewmode.component';
import { Stage2viewmodeComponent } from './components/projects/project-stages/plan-sections/stage2viewmode/stage2viewmode.component';
import { AccordionComponent } from '@/app/components/projects/project-stages/accordion/accordion.component';
import { Stage2navcallComponent } from './components/projects/project-stages/plan-sections/stage2navcall/stage2navcall.component';
import { TooltipsComponent } from './components/shared/tooltips/tooltips.component';
import { MeasurementStandardsComponent } from './components/projects/project-stages/plan-sections/measurement-standards/measurement-standards.component';
import { ProjectStagesComponent } from '@/app/components/projects/project-stages/project-stages.component';
import { Stage3navComponent } from '@/app/components/projects/project-stages/project-design/stage3nav/stage3nav.component';
import { DialogContentExampleDialogComponent } from '@/app/components/projects/project-stages/project-design/dialog-content-example-dialog/dialog-content-example-dialog.component';
import { Stage3navcallComponent } from '@/app/components/projects/project-stages/project-design/stage3navcall/stage3navcall.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { DesignDocumentsComponent } from './components/projects/project-stages/project-design/design-documents/design-documents.component';
import { ThemeSelectorComponent } from './components/theme-selector/theme-selector.component';
import { TenderingComponent } from './components/projects/project-development/tendering/tendering.component';
import { ProjectExpressionOfInterestComponent } from './components/projects/project-development/tendering/project-expression-of-interest/project-expression-of-interest.component';
import { BriefViewHistoryComponent } from './components/projects/project-stages/project-brief/stage1viewmode/brief-view-history/brief-view-history.component';
import { BriefPlanViewComponent } from './components/projects/project-stages/brief-plan-view/brief-plan-view.component';
import { PQQComponent } from './components/projects/project-development/tendering/pqq/pqq-developer/pqq.component';
import { IntiateExpressionOfInterestComponent } from './components/projects/project-development/tendering/project-expression-of-interest/intiate-expression-of-interest/intiate-expression-of-interest.component';
import { EoiHistoryComponent } from './components/projects/project-development/tendering/project-expression-of-interest/eoi-history/eoi-history.component';
import { ApplicantEoiViewComponent } from './components/projects/project-development/tendering/project-expression-of-interest/eoi-history/applicant-eoi-view/applicant-eoi-view.component';
import { ProjectRequestsComponent } from './components/projects/project-requests/project-requests.component';
import { RequestedTenderingComponent } from './components/projects/project-requests/requested-tendering/requested-tendering.component';
import { PqqHistoryComponent } from './components/projects/project-development/tendering/pqq/pqq-developer/pqq-history/pqq-history.component';
import { PqqFinalFormComponent } from './components/projects/project-development/tendering/pqq/pqq-developer/pqq-final-form/pqq-final-form.component';
import { RequestedEoisComponent } from './components/projects/project-requests/requested-tendering/requested-eois/requested-eois.component';
import { RequestedPqqListingComponent } from './components/projects/project-requests/requested-tendering/requested-pqq/requested-pqq-listing/requested-pqq-listing.component';
import { EoiRequestViewComponent } from '@/app/components/projects/project-requests/requested-tendering/requested-eois/eoi-request-view/eoi-request-view.component';
import { IndividualPqqViewComponent } from './components/projects/project-requests/requested-tendering/requested-pqq/requested-pqq-listing/individual-pqq-view/individual-pqq-view.component';
import { IndividualPqqViewSubmitComponent } from './components/projects/project-requests/requested-tendering/requested-pqq/requested-pqq-listing/individual-pqq-view-submit/individual-pqq-view-submit.component';
import { IttListingComponent } from './components/projects/project-development/tendering/inivitation-to-tender/itt-sender-side/itt-listing/itt-listing.component';
import { IttOrganizationDetailFormComponent } from './components/projects/project-development/tendering/inivitation-to-tender/itt-sender-side/itt-organization-detail-form/itt-organization-detail-form.component';
import { InivitationToTenderViewComponent } from './components/projects/project-development/tendering/inivitation-to-tender/inivitation-to-tender-view/inivitation-to-tender-view.component';
import { RfpClarificationWrapperComponent } from '@/app/components/projects/project-development/tendering/inivitation-to-tender/itt-sender-side/Clarification/rfp-clarification-wrapper/rfp-clarification-wrapper.component';
import { RequestedIttComponent } from './components/projects/project-requests/requested-tendering/requested-itt/requested-itt.component';
import { IndividualIttViewComponent } from './components/projects/project-requests/requested-tendering/requested-itt/individual-itt-view/individual-itt-view.component';
import { AuthGuard } from './services/auth/auth-guard.service';
import { OtpRecoverAccountMessageComponent } from './components/auth/recover-account/otp-recover-account-message/otp-recover-account-message.component';
import { RfpApplicantClarificationWrapperComponent } from '@/app/components/projects/project-requests/requested-tendering/requested-itt/rfp-applicant-clarification-wrapper/rfp-applicant-clarification-wrapper.component';
import { SelectedDrawingReviewComponent } from './components/projects/project-stages/project-design/initial-drawing-info/selected-drawing-review/selected-drawing-review.component';
import { UserRoleManagementComponent } from './components/auth/user-role-management/user-role-management.component';
import { ListingComponent } from './archive-components/RFI/listing/listing.component';
import { CreateRfiComponent } from './archive-components/RFI/create-rfi/create-rfi.component';
import { RfiWrapperComponent } from './archive-components/RFI/rfi-wrapper/rfi-wrapper.component';
import { RFIComponent } from './components/projects/RFI/RFI.component';
import { ContractorRfiViewComponent } from './components/projects/RFI/contractor/contractor-rfi-view/contractor-rfi-view.component';
import { ClientRfiViewComponent } from './components/projects/RFI/client/client-rfi-view/client-rfi-view.component';
export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'user-role-management',
        component: UserRoleManagementComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'project-stages',
        component: ProjectStagesComponent,
        canActivate: [AuthGuard],
      },
      { path: '', component: ProjectsComponent, canActivate: [AuthGuard] },
      {
        path: 'projects',
        component: ProjectsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'project-development/:projectId',
        component: ProjectDevelopmentComponent,
      },
      {
        path: 'project-revision',
        component: RevisionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ':projectId/tendering',
        component: TenderingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'expression-of-interest',
        component: ProjectExpressionOfInterestComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'pre-qualification-questionnaire',
        component: PQQComponent,
        canActivate: [AuthGuard],
      },
      // Project Drawings
      {
        path: 'project-design/:document-type',
        component: DesignDocumentsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'selected-drawing',
        component: SelectedDrawingReviewComponent,
      },
      // End Project Drawings
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-project',
        component: AddProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-stage-1',
        component: OverviewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'stage1-viewmode',
        component: Stage1viewmodeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'brief-plan-view',
        component: BriefPlanViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'brief-history-viewmode',
        component: BriefViewHistoryComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-stage-2',
        component: PlanSectionsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'stage2-viewmode',
        component: Stage2viewmodeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'eoi-submissions',
        component: EoiHistoryComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'pqq-submissions',
        component: PqqHistoryComponent,
        canActivate: [AuthGuard],
      },
      /**ITT SECTION */
      /**
       * We will use rfp instead of itt
       *
       */
      // {
      //   path: ':projectId/tendering/itt',
      //   component: IttListingComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'initiate-itt/:projectId/:ittId',
      //   component: IttOrganizationDetailFormComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'itt-view',
      //   component: InivitationToTenderViewComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'projects/:projectId/rfp/:ittId/show',
      //   component: IndividualIttViewComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'projects/:projectId/rfp/:rfpId/clarifications',
      //   component: RfpClarificationWrapperComponent,
      //   canActivate: [AuthGuard],
      // },
      /**END ITT */

      /**RFP SECTION */
      {
        path: ':projectId/tendering/rfp',
        component: IttListingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'initiate/rfp/:projectId/:ittId',
        component: IttOrganizationDetailFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'rfp/view',
        component: InivitationToTenderViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'projects/:projectId/rfp/:ittId/show',
        component: IndividualIttViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'projects/:projectId/rfp/:rfpId/clarifications',
        component: RfpClarificationWrapperComponent,
        canActivate: [AuthGuard],
      },
      /**END ITT */

      /**RFQ SECTION */
      {
        path: ':projectId/tendering/rfq',
        component: IttListingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'initiate/rfq/:projectId/:ittId',
        component: IttOrganizationDetailFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'rfq/view',
        component: InivitationToTenderViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'projects/:projectId/rfq/:ittId/show',
        component: IndividualIttViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'projects/:projectId/rfq/:rfpId/clarifications',
        component: RfpClarificationWrapperComponent,
        canActivate: [AuthGuard],
      },
      /**END RFP */

      {
        path: 'applicant-eoi-view/:id',
        component: ApplicantEoiViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'initiate-eoi/:projectId/:eoiId',
        component: IntiateExpressionOfInterestComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'initiate-pqq/:projectId/:pqqId',
        component: PqqFinalFormComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'measurement-standards',
        component: MeasurementStandardsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'nrm-strategy',
        component: IttWorkPackagesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'custom-strategy',
        component: CustomGeneratedComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'generate-manually',
        component: ManualGeneratedComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'cost-estimation',
        component: CostEstimationComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'work-distribution',
        component: RaciMatrixComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'risk-assessment',
        component: RiskAssessmentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-risk',
        component: AddRiskComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'tooltips',
        component: TooltipsComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'stage2nav',
        component: Stage2navcallComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'stage3nav',
        component: Stage3navcallComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'stage3nav',
        component: Stage3navComponent,
        children: [],
        canActivate: [AuthGuard],
      },
      {
        path: 'DialogContentExampleDialog',
        component: DialogContentExampleDialogComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'accord',
        component: AccordionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'appearance',
        component: ThemeSelectorComponent,
        canActivate: [AuthGuard],
      },

      // Project requested paths

      {
        path: 'pqq-requests',
        component: RequestedPqqListingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'requests/rfp',
        component: RequestedIttComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'requests/rfq',
        component: RequestedIttComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'applicant-individual-pqq-view/:pqqId',
        component: IndividualPqqViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'applicant-individual-pqq-submit-view',
        component: IndividualPqqViewSubmitComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'project-requests/:projectId',
        component: ProjectRequestsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'requested-tendering/:projectId',
        component: RequestedTenderingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'eoi-requests/:projectId',
        component: RequestedEoisComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'eoi-request-detail/:projectId/:eoiId',
        component: EoiRequestViewComponent,
        canActivate: [AuthGuard],
      },

      // This rfi will be deleted, when the new  rfi flow is implemented. This is the old rfi flow and their components is in the archive sections
      {
        path: 'rfi-listing1',
        component: ListingComponent,

        canActivate: [AuthGuard],
      },
      {
        path: 'rfi-wrapper',
        component: RfiWrapperComponent,

        canActivate: [AuthGuard],
      },

      // New RFI flow
      {
        path: 'rfi-listing',
        component: RFIComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'create-rfi',
        component: CreateRfiComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'contractor/rfi-view/:projectId/:rfiId',
        component: ContractorRfiViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'client/rfi-view/:projectId/:rfiId',
        component: ClientRfiViewComponent,
        canActivate: [AuthGuard],
      },

      // CLOSE RFI

      /**
       * RFP SECTION STARTS
       */
      {
        path: 'projects/:projectId/rfp/:rfpId/clarifications/applicant',
        component: RfpApplicantClarificationWrapperComponent,
        canActivate: [AuthGuard],
      },
      /**
       * RFP SECTION ENDS
       */
    ],
  },

  { path: 'login', component: HomeComponent },

  { path: 'register', component: RegisterComponent },
  {
    path: 'verification',
    component: VerificationComponent,
  },

  {
    path: 'paymentplan',
    component: PaymentPlanComponent,
  },
  {
    path: 'payment-details',
    component: PaymentDetailsComponent,
  },
  {
    path: 'recover-account',
    component: RecoverAccountComponent,
  },
  {
    path: 'otp-recover-account-message',
    component: OtpRecoverAccountMessageComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'multi-select',
    component: MultiSelectBoxExampleComponent,
  },
  {
    path: 'notification',
    component: NotificationsComponent,
    canActivate: [AuthGuard],
  },
];
